// extracted by mini-css-extract-plugin
export default {"top_ad":"index_top_ad_Onh3G","main":"index_main_EYNf1","passAd":"index_passAd_n73Qk","footer_ad":"index_footer_ad_3IVim"};